import { Layout } from '@/features/auth/components/Layout';
import { RegistrationForm } from '@/features/auth/components/RegistrationForm';

export const RegistrationPage = () => {
  return (
    <Layout>
      <RegistrationForm />
    </Layout>
  );
};
